export default "__VITE_ASSET__DcEMb_D5__"